<div class="dialog confirm-dialog change-tags-dialog">
  <mat-icon class="dialog__close" aria-hidden="false" aria-label="Close icon" mat-dialog-close>close</mat-icon>
  <div mat-dialog-title>
    {{ changeTagService.entity | uppercase }} {{ 'recordsClipboard.tagUpdateTitle' | xTranslate }}
  </div>

  <div mat-dialog-content class="change-tags-container">
    <mat-radio-group
      [(ngModel)]="selectedChangeType"
      aria-label="Select an option"
      class="options"
      (change)="typeChanged()"
    >
      <mat-radio-button [value]="types.Add" l10nTranslate>recordsClipboard.addTag</mat-radio-button>
      <mat-radio-button [value]="types.Update" l10nTranslate>recordsClipboard.updateTag</mat-radio-button>
      <mat-radio-button [value]="types.Remove" l10nTranslate>recordsClipboard.removeTag</mat-radio-button>
    </mat-radio-group>
    <div class="tags-handlers">
      <div class="remove-tag-section" *ngIf="showRemove">
        <ng-container *ngIf="availableTagsToDelete$ | async as availableTags; else loadingTags">
          <span class="label" l10nTranslate>recordsClipboard.tagsToBeRemoved</span>
          <mat-form-field floatLabel="never" appearance="outline">
            <mat-select
              hideSingleSelectionIndicator="true"
              [(ngModel)]="tagsToDelete"
              multiple
              (selectionChange)="deleteTagSelectionChanged()"
            >
              <mat-option *ngFor="let tag of availableTags" [value]="tag.key">{{ tag.value }}</mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
        <ng-template #loadingTags>
          <span class="label" l10nTranslate>recordsClipboard.loadingTagsToDelete</span>
        </ng-template>
      </div>
      <div class="add-tag-section" *ngIf="showAdd">
        <miq-tags
          [addTag]="onAddTag"
          [deleteTag]="onDeleteTag"
          [filterStreamFn]="filterTags"
          [tags]="selectedTags"
          [canEdit]="true"
        >
        </miq-tags>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-flat-button color="primary" [disabled]="buttonDisabled" (click)="done()" l10nTranslate>
    shared.done
  </button>
</div>
